import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FormUtility } from '../../../shared/forms/form-utility';
import { FormValidation } from '../../../shared/forms/form-validation';
import { ClaimsAppSubmissionConstant } from '../models/claims-app-submission.constant';
import { maxDateValidator } from '../../../shared/custom-validators/max-date.directive';

@Component({
  selector: 'claims-app-mechanical-breakdown',
  templateUrl: './claims-app-mechanical-breakdown.component.html',
})
export class ClaimsAppMechanicalBreakdownComponent implements OnInit {
  public form: UntypedFormGroup;  
  public formCompleted = false;
  
  public readonly minCurrentOdometer = 0;
  public readonly maxCurrentOdometer = 9999999;
  
  public readonly driveIn = ClaimsAppSubmissionConstant.driveIn;
  public readonly towedIn = ClaimsAppSubmissionConstant.towedIn;
  public hasTransportationMode = true;
  public today = new Date();

  public faInfo = faCircleQuestion;
  
  ngOnInit(): void {
    
    this.form = new UntypedFormGroup({
      'breakdownDate': new UntypedFormControl("", [Validators.required, maxDateValidator(this.today)]),
      'currentOdometer': new FormControl<number>(null, [Validators.required]),
      'transportationMode': new UntypedFormControl(null, [Validators.required]),
      'isCollision': new FormControl<boolean>(false), 
      'hasModification': new FormControl<boolean>(false), 
      'IsCommercialUse': new FormControl<boolean>(false), 
      'repairOrderNumber': new UntypedFormControl("", [Validators.required, Validators.maxLength(20)]),
    });
  }
  
  /*
   * Enforces max length of currentMileage field.
   */
  public onCurrentOdometerChange(): void {
    let controlValue = this.form.controls['currentOdometer']?.value;
    if (controlValue < this.minCurrentOdometer) {
      this.form.controls['currentOdometer'].setValue(this.minCurrentOdometer);
    }
    else if (controlValue > this.maxCurrentOdometer) {
      // If entering a a digit past max, truncate it.
      var targetValue = String(controlValue).substring(0, 6);
      this.form.controls['currentOdometer'].setValue(targetValue);
    }
  }

  public validateTransportationMode(): void {
    var transportationModeValue = this.form.controls['transportationMode']?.value;
    this.hasTransportationMode = transportationModeValue !== null
                                 && transportationModeValue !== undefined;
  }

  //** Validates the customer form and sets formCompleted to valid or invalid */
  public validateForm(): void {
    this.validateTransportationMode();

    this.formCompleted = FormValidation.isValid(this.form)
                         && this.hasTransportationMode;
  }

  /**
   * Resets the form.
   * @see {@link FormUtility.reset}
   */
  public reset(): void {
    FormUtility.reset(this.form);
    this.formCompleted = false;
  }
  
  /**
   * Clears the value in the specified form field.
   * @param field The form field to clear.
   */
  public clear(field: string): void {
    FormUtility.clear(this.form, field);
  }

  /**
   * Gets a value indicating if the specified field has a value.
   * @param field The form field to check.
   * @returns If the field has a value, `true`; otherwise, `false`.
   */
  public hasValue(field: string): boolean {
    return FormUtility.hasValue(this.form, field)
  }
}
